'use strict';
import {DevStackSelectable} from "./DevStackCriteria";

// -----------------------------------------------------------------------------------
/**
 * Simple Criterion
 */
export var CriteriaColumn = function (name) {

    /** Class type */
    this.type = DevStackSelectable.COLUMN;

    /** Managed columns */
    this.name = name;
};
